module.exports = __webpack_public_path__ + "img/1574738147.24c3af75.jpg";